import { Component, Inject } from '@angular/core';
import { ListBase } from "../shared/list.base";
import { Principal } from '../../shared/auth/principal.service';
import { CrewPermissionsService } from '../../core/crew-permissions.service';

@Component({
    selector: 'crew-activitytypes',
    template: require('../shared/list-view.html')
})
export class ActivityTypes extends ListBase<Nema.Crew.Model.ActivityType>  {
    constructor(
        @Inject("activityTypes") activityTypes: Nema.Crew.Model.ActivityType[],
        _bla: Principal,
        crewPermissionsService: CrewPermissionsService) {

        super(activityTypes, crewPermissionsService);
    }

    public newEntityState = "app.settings.activitytypes.new";

    public editEntityState = "app.settings.activitytypes.detail";

    public entityName = "Activity";

    public entityNames = "Activities";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/activitytypes/activitytypes.component.ts